import http from 'hub-http/clients/apiClient';
import { queryQuickFetch } from './earlyRequestHelper';
import { EARLY_REQUESTER_KEYS } from '../constants/EarlyRequesterKeys';
const PIPELINES_URI = 'pipelines/v2/pipelines/0-3';
export const fetchPipelines = () => queryQuickFetch(EARLY_REQUESTER_KEYS.PIPELINES, () => http.get(`${PIPELINES_URI}`));
export const fetchSpecificPipeline = pipelineId => http.get(`${PIPELINES_URI}/${pipelineId}`);